import React, { useState } from 'react';

import Collapse from '@kunukn/react-collapse';
import JurisdictionGroups from '../../JurisdictionGroups';
import SourceLinks from '../../../SourceLinks';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import flattenDeep from 'lodash/flattenDeep';
import unique from 'lodash/uniq';

const apDate = (date) => {
  const months = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
};

const SummaryRow = (props) => {
  const { jurisdiction, usState, phaseProgress } = props;
  const [showDetail, setShowDetail] = useState(false);
  const jurisdictionSlug = jurisdiction.name.replace(' ', '-');

  const humanizePercent = (percent) => {
    const p = parseInt(percent * 100);
    if (p < 1) return '<1%';
    if (p > 99) return '>99%';
    return `${p}%`;
  };

  const updatedDates = unique(flattenDeep(
    jurisdiction.phases
        .map(p => p.priorityGroups
          .filter(g => g.priorityConditions)
          .map(g => g.lastUpdated))));
  updatedDates.sort((a, b) => new Date(b) - new Date(a));
  const lastUpdated = new Date(updatedDates[0]);

  // console.log('jurisdiction', jurisdiction);

  return (
    <div
      className={classnames(component)}
      id={`#priority-groups-for-${jurisdictionSlug}`}
    >
      <div
        className={classnames('row', { expanded: Boolean(showDetail) }, { 'us-state': Boolean(usState) })}
        onClick={() => setShowDetail(!showDetail)}
      >
        <div className='jurisdiction-name inline'>
          {jurisdiction.name}
        </div>
        {usState && (
          <div className='vaccinated inline'>
            <div className='bar-backer inline'>
              <div className='bar' style={{ width: (usState.dose1_Administered / usState.population) * 100 + '%' }} />
            </div>
            <div className='bar-label inline'>
              <p>{humanizePercent(usState.dose1_Administered / usState.population)}</p>
            </div>
          </div>
        )}
        <div className='phase-progress inline'>
          {(phaseProgress[0] > 0) && (
            <>
              <div className='current-phase inline'>
                <div className='bullet'>
                  {phaseProgress[0]}
                </div>

              </div>
              <div className='total-phases inline'>
                of {phaseProgress[1]}
              </div>
            </>
          )}
        </div>
      </div>
      <Collapse
        isOpen={showDetail}
      >
        <h4 className='updated'><small>Last updated {apDate(lastUpdated)}</small></h4>
        <JurisdictionGroups jurisdiction={jurisdiction} />
        <div className='source-links'>
          {(jurisdiction.sources.length > 0) && (
            <SourceLinks sources={jurisdiction.sources} />
          )}
        </div>
      </Collapse>

    </div>
  );
};

export default SummaryRow;
